
import { defineComponent, watchEffect } from 'vue';
import { CoupomService } from './coupom.service';
import dayjs from 'dayjs';
const coupomService = new CoupomService();

export default defineComponent({
    name: 'TableViewIndividual',
    emits: ['delete-coupom', 'delete-lot', 'download-csv'],
    props: {
        dataCoupom: {
            type: Array,
            required: true
        },
        loaderTable: {
            type: Boolean
        }
    },
    setup(props, {emit}) {
        const onDelete = (id: any) => {
            emit('delete-coupom', id);
        }

        return {
            onDelete
        }
    },

    methods:{
        deleteCoupomEmit(){
            this.$emit('delete-coupom');
        },

        formatDate(date: string){
            return dayjs(date).format('DD/MM/YYYY');
        },
    },

    data(){
        return{
            params:{ page: 0, size: 10, total: 0},
        }
    },
    mounted(){
    }
})
